import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../context/ThemeContext";
import { getClaimTypeChipStyle } from "./claimTypeColors.ts";

/** The type of a claim as a small tag in the colour of that type. */
const ClaimTypeChip = ({
  type,
  label,
  disabled,
}: {
  type: string;
  label?: string;
  disabled?: boolean;
}) => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  const { backgroundColor, color } = getClaimTypeChipStyle(type, theme);

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 1.1,
        py: 0.4,
        borderRadius: 1.25,
        typography: "caption",
        fontWeight: 600,
        lineHeight: 1.3,
        whiteSpace: "nowrap",
        bgcolor: backgroundColor,
        color,
        opacity: disabled ? theme.palette.action.disabledOpacity : undefined,
      }}
    >
      {label ?? t(`claimTypeChip.claimTypes.${type}`)}
    </Box>
  );
};

export default ClaimTypeChip;
